export const matchDetailUrl = (matchId: number, riotGameId?: number): string => {
  const base = `/matches/${String(matchId)}`;
  if (riotGameId != null && riotGameId > 0) {
    return `${base}?gameId=${String(riotGameId)}`;
  }
  return base;
};

export const gameIndexFromRiotGameId = (
  games: { game_id: number }[],
  riotGameId: number,
): number | null => {
  const index = games.findIndex((game) => game.game_id === riotGameId);
  return index >= 0 ? index : null;
};
